import { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';

export const FormOverlay = (props: any) => {
  return <AppointmentForm.Overlay {...props} style={{ borderRadius: 24 }} />;
};
